export const es: Record<string, string> = {
  'nav.leagues_load_failed': 'No se han podido cargar tus ligas. Vuelve a abrir el menú para reintentar.',
  'api.calls_count': '{count} llamadas registradas',
  'api.clear': 'Limpiar registro de llamadas',
  'api.filter_method': 'Método:',
  'api.latency': 'Latencia: {ms} ms',
  'api.latency_hint': 'Latencia simulada media: ~180ms · HTTP/2',
  'api.no_calls': 'No hay llamadas registradas todavía. Realiza cualquier acción en el juego.',
  'api.payload': 'Payload de la Petición (Request Body):',
  'api.response': 'Respuesta del Servidor (Mocked Response):',
  'api.select_hint': 'Haz clic en cualquier petición de la lista para ver su payload y respuesta mockeada en formato JSON.',
  'api.status_ok': 'Estado: {status} OK',
  'api.subtitle': 'Registro en tiempo real de llamadas simuladas a la capa de servicios',
  'api.time': 'Hora: {time}',
  'api.title': 'Consola de Endpoints REST (Mock Responses)',
  'auth.authenticating': 'Autenticando en el servidor...',
  'auth.demo_hint': 'Haz clic en el acceso rápido para entrar como Mánager Oficial con datos precargados.',
  'auth.email': 'Correo Electrónico',
  'auth.enter_credentials': 'Introduce tus credenciales para acceder a la gestión de tu club.',
  'auth.err_email_required': 'El usuario o correo es obligatorio',
  'auth.err_password_required': 'La contraseña es obligatoria',
  'auth.feat_finance': 'Estadio, módulo comercial, préstamos y contabilidad',
  'auth.feat_market': 'Mercado de fichajes, cláusulas y negociación objetiva',
  'auth.feat_squad': 'Gestión de plantilla, tácticas y cantera',
  'auth.password': 'Contraseña',
  'auth.password_required': 'La contraseña es obligatoria',
  'auth.quick_access': 'Acceso de Prueba Rápido (1 Clic)',
  'auth.remember_me': 'Recordar sesión',
  'auth.submit': 'Acceder a la Oficina del Mánager',
  'auth.subtitle': 'Simulador de gestión deportiva profesional con motor de partidos, economía y mercado en vivo.',
  'auth.user_placeholder': 'usuario@ejemplo.com o tu usuario',
  'auth.user_required': 'El usuario o correo es obligatorio',
  'auth.welcome': 'Bienvenido a League of Managers',
  'auth.google_continue': 'Continuar con Google',
  'auth.google_checking': 'Comprobando tu sesión…',
  'auth.google_err_cancelled': 'Has cancelado el acceso con Google.',
  'auth.google_err_expired': 'El intento ha caducado o ya se ha utilizado. Vuelve a intentarlo.',
  'auth.google_err_not_allowed': 'Esta cuenta no está habilitada para la prueba con Google.',
  'auth.google_err_unavailable': 'No se ha podido iniciar sesión. Vuelve a intentarlo.',
  'auth.google_back_to_login': 'Volver al inicio de sesión',
  'auth.register_title': 'Crear Cuenta de Mánager',
  'auth.register_subtitle': 'Regístrate para dirigir tu club y competir en League of Managers.',
  'auth.register_btn': 'Crear cuenta',
  'auth.register_creating': 'Creando cuenta…',
  'auth.repeat_password': 'Confirmar Contraseña',
  'auth.repeat_password_required': 'Debes repetir la contraseña',
  'auth.passwords_must_match': 'Las contraseñas no coinciden',
  'auth.password_min_length': 'La contraseña debe tener al menos 8 caracteres',
  'auth.password_max_length': 'La contraseña no puede exceder 128 caracteres',
  'auth.email_invalid': 'Introduce un correo electrónico válido',
  'auth.email_max_length': 'El correo no puede superar los 254 caracteres',
  'auth.register_success_title': 'Comprueba tu correo',
  'auth.register_success_neutral_msg': 'Si procede el registro, recibirás un correo para confirmar tu cuenta; si ya tienes cuenta, utiliza tu método de acceso habitual.',
  'auth.resend_btn': 'Reenviar correo de confirmación',
  'auth.resend_wait': 'Reenviar en {seconds}s',
  'auth.resend_sending': 'Reenviando…',
  'auth.resend_sent': 'Si la cuenta está pendiente de confirmación, hemos reenviado el correo.',
  'auth.has_account': '¿Ya tienes cuenta? Inicia sesión',
  'auth.no_account': '¿No tienes cuenta? Regístrate',
  'auth.err_email_not_verified': 'Tu correo electrónico aún no ha sido confirmado. Revisa tu bandeja de entrada o solicita un nuevo enlace.',
  'auth.err_invalid_request': 'Revisa los datos introducidos. La contraseña debe tener entre 8 y 128 caracteres.',
  'auth.err_rate_limited': 'Has realizado demasiadas solicitudes. Espera un momento antes de volver a intentarlo.',
  'auth.err_unavailable': 'El servicio no está disponible temporalmente. Inténtalo más tarde.',
  'auth.err_registration_disabled': 'El registro de cuentas no está disponible en este momento.',
  'auth.verify_title': 'Confirmación de Correo Electrónico',
  'auth.verify_subtitle': 'Pulsa el botón para activar tu cuenta de mánager en League of Managers.',
  'auth.verify_btn': 'Confirmar correo',
  'auth.verify_confirming': 'Confirmando tu correo…',
  'auth.verify_success_title': '¡Correo confirmado con éxito!',
  'auth.verify_success_desc': 'Tu cuenta ya está activa. Ya puedes iniciar sesión con tu correo y contraseña.',
  'auth.verify_go_to_login': 'Ir a Iniciar Sesión',
  'auth.verify_err_invalid_token': 'El enlace de confirmación es inválido, ha caducado o ya se ha utilizado.',
  'auth.verify_err_resend_title': '¿Necesitas un nuevo enlace?',
  'auth.verify_err_resend_desc': 'Introduce tu correo para recibir un nuevo enlace de activación.',
  'auth.verify_enter_email': 'Introduce tu correo electrónico',
  'auth.verify_request_new_link': 'Solicitar nuevo enlace',
  'auth.verify_missing_token': 'No se ha proporcionado ningún token de confirmación en el enlace.',
  'club.accounting_version': 'Versión contable',
  'club.active_loans': 'activa(s)',
  'club.available_balance': 'Saldo Disponible en Caja',
  'club.currency': 'Moneda',
  'club.healthy_accounts': 'Cuentas Saneadas',
  'club.ledger_col_amount': 'Importe',
  'club.ledger_col_balance': 'Balance',
  'club.ledger_col_concept': 'Concepto',
  'club.ledger_col_date': 'Fecha',
  'club.ledger_col_origin': 'Origen',
  'club.ledger_col_type': 'Tipo',
  'club.ledger_desc': 'Registro contable',
  'club.ledger_entries': 'movimientos',
  'club.ledger_expense': 'GASTO',
  'club.ledger_income': 'INGRESO',
  'club.ledger_title': 'Registro contable',
  'club.modules_synced': 'Módulos comerciales y explotación sincronizados',
  'club.no_ledger_entries': 'No hay apuntes contables registrados en el libro mayor.',
  'club.reserved_balance': 'Garantías / Fondos Comprometidos',
  'club.solvency_desc': 'Control patrimonial oficial de la entidad. Las finanzas del club se liquidan estrictamente en euros (€).',
  'club.solvency_title': 'Estado de Solvencia y Liquidez',
  'club.total_balance': 'Balance Total Auditado',
  'club.treasury_audited': 'Tesorería auditada en tiempo real',
  'common.all': 'Todos',
  'common.back': 'Volver',
  'common.cancel': 'Cancelar',
  'common.close': 'Cerrar',
  'common.confirm': 'Confirmar',
  'common.delete': 'Eliminar',
  'common.edit': 'Modificar',
  'common.live': 'En directo',
  'common.loading': 'Cargando...',
  'common.retry': 'Reintentar',
  'common.save': 'Guardar',
  'common.today': 'Hoy',
  'common.version': 'Versión',
  'common.yesterday': 'Ayer',
  'comp.advance_round': 'Avanzar a Jornada {round}',
  'comp.badge': 'Primera División',
  'comp.box_office': 'Recaudación Taquilla',
  'comp.calendar_title': 'Calendario de Partidos',
  'comp.close': 'Cerrar',
  'comp.club_col': 'Club',
  'comp.col_club': 'Club',
  'comp.col_dg': 'DG',
  'comp.col_form': 'Forma',
  'comp.col_gc': 'GC',
  'comp.col_gf': 'GF',
  'comp.col_pe': 'PE',
  'comp.col_pg': 'PG',
  'comp.col_pj': 'PJ',
  'comp.col_pos': '#',
  'comp.col_pp': 'PP',
  'comp.col_pts': 'Pts',
  'comp.current_round': 'Jornada en curso:',
  'comp.final_score': 'Resultado Final',
  'comp.finished': 'FINALIZADA',
  'comp.form_col': 'Forma',
  'comp.goalscorers': 'Goleadores',
  'comp.group_id_prefix': 'ID de Grupo: ',
  'comp.group_label': 'Grupo',
  'comp.in_progress': 'EN JUEGO',
  'comp.league_desc': 'Liga regular de 6 clubes · 30 jornadas ida y vuelta.',
  'comp.legend_champions': 'Champions League',
  'comp.legend_conf': '7º Conference League',
  'comp.legend_conference': 'Conference League',
  'comp.legend_direct_promotion': 'Ascenso directo',
  'comp.legend_europa': 'Europa League',
  'comp.legend_playoff': 'Playoff de ascenso',
  'comp.legend_rel': '17-20º Descenso Directo',
  'comp.legend_relegation': 'Descenso',
  'comp.legend_ucl': '1-4º Champions League',
  'comp.legend_uel': '5-6º Europa League',
  'comp.live_standings': 'Clasificación en Vivo',
  'comp.loading_fixtures': 'Cargando partidos de la jornada...',
  'comp.loading_round': 'Cargando jornada...',
  'comp.loading_standings': 'Cargando clasificación del grupo...',
  'comp.match_detail': 'Detalle de Partido',
  'comp.match_detail_title': 'Detalle',
  'comp.next_round': 'Jornada siguiente',
  'comp.no_fixtures': 'No hay partidos programados para esta jornada.',
  'comp.official_calendar': 'Calendario oficial',
  'comp.prev_round': 'Jornada anterior',
  'comp.refresh_standings': 'Actualizar clasificación en vivo',
  'comp.round_header': 'Jornada {current} de {total}',
  'comp.round_of': 'de',
  'comp.round_prefix': 'Jornada',
  'comp.scorers': 'Goleadores',
  'comp.simulate_round': 'Simular Jornada {round}',
  'comp.spectators': 'Espectadores',
  'comp.standings_title': 'Clasificación en Vivo',
  'comp.status': 'Estado',
  'comp.subtitle': 'Liga regular de 20 clubes · 38 jornadas ida y vuelta · 4 descensos directos.',
  'comp.ticket_revenue': 'Recaudación Taquilla',
  'comp.tiebreaker': 'Desempate: Pts · DG · GF',
  'comp.tiebreaker_legend': 'Desempate: Pts · DG · GF',
  'comp.title': 'Competición Oficial',
  'comp.you': 'TÚ',
  'comp.you_badge': 'TÚ',
  'dashboard.away': 'Visitante',
  'dashboard.current_position': 'Tu posición actual: {pos}º clasificado con {pts} puntos',
  'dashboard.edit_lineup': 'Modificar Alineación',
  'dashboard.forecast_attendance': 'Previsión de Asistencia',
  'dashboard.forecast_revenue': 'Ingresos Estimados',
  'dashboard.home': 'Local',
  'dashboard.kpi_budget': 'Presupuesto para Fichajes',
  'dashboard.kpi_budget_sub': 'Fondos disponibles sin comprometer',
  'dashboard.kpi_stadium': 'Aforo del Estadio',
  'dashboard.kpi_stadium_sub': 'Capacidad actual',
  'dashboard.kpi_staff': 'Nivel Cuerpo Técnico',
  'dashboard.kpi_staff_sub': 'Media estrellas 4 preparadores',
  'dashboard.kpi_ticket': 'Precio Entrada General',
  'dashboard.kpi_ticket_sub': 'Fijado para la temporada',
  'dashboard.lineup_incomplete': 'Alineación incompleta ({current}/11 seleccionados)',
  'dashboard.lineup_ready': 'Alineación completa y lista',
  'dashboard.lineup_unavailable': 'No se ha podido consultar la alineación',
  'dashboard.local_badge': 'Local',
  'dashboard.away_badge': 'Visitante',
  'dashboard.news_count_plural': 'noticias',
  'dashboard.news_count_single': 'noticia',
  'dashboard.news_desc': 'Últimos movimientos oficiales, traspasos confirmados y actualidad del campeonato',
  'dashboard.news_empty': 'No hay noticias o traspasos registrados en esta competición actualmente.',
  'dashboard.news_live': 'En directo',
  'dashboard.news_loading': 'Cargando noticias y traspasos de la liga...',
  'dashboard.news_title': 'Noticias y Fichajes',
  'dashboard.news_today': 'HOY',
  'dashboard.news_view_market': 'Ver Mercado',
  'dashboard.news_yesterday': 'AYER',
  'dashboard.next_match': 'Jornada {round}',
  'dashboard.play_round': 'Disputar Jornada {round}',
  'dashboard.quick_finance_desc': 'Amplía gradas, mejora módulos comerciales, contrata preparadores y gestiona líneas de crédito.',
  'dashboard.quick_finance_title': 'Estadio y Finanzas',
  'dashboard.quick_market_desc': 'Ficha agentes libres, ejecuta cláusulas de rescisión o pon en venta futbolistas transferibles.',
  'dashboard.quick_market_title': 'Mercado de Fichajes',
  'dashboard.quick_squad_desc': 'Define la formación táctica (4-3-3, 4-4-2, etc.), asigna dorsales y ajusta el once para el partido.',
  'dashboard.quick_squad_title': 'Plantilla y Once Titular',
  'dashboard.retry': 'Reintentar',
  'dashboard.season_info': '2026/27 · Jornada {round} de {total}',
  'dashboard.see_results': 'Ver Resultados y Tabla',
  'dashboard.stadium_label': 'Estadio',
  'dashboard.standings_full': 'Ver tabla completa',
  'dashboard.standings_title': 'Clasificación',
  'dashboard.starters_count': 'Once Titular',
  'dashboard.status_closed': 'Cerrada',
  'dashboard.status_label': 'Estado',
  'dashboard.status_locked': 'Bloqueada',
  'dashboard.status_open': 'Abierta',
  'dashboard.status_scored': 'Disputada',
  'leagues.acronym_label': 'Acrónimo (3 letras)',
  'leagues.active_badge': 'Liga Activa',
  'leagues.active_game': 'Partida en curso',
  'leagues.cancel': 'Cancelar',
  'leagues.club_name_in_league': 'Nombre de tu Club en esta Liga',
  'leagues.code_placeholder': 'Ej. PRIV-88219',
  'leagues.code_prefix': 'Código',
  'leagues.create_action': 'Crear Liga',
  'leagues.create_and_join': 'Crear Club y Unirse',
  'leagues.create_btn': 'Crear Liga Privada',
  'leagues.create_modal_title': 'Crear Nueva Liga Privada',
  'leagues.create_new_league': 'Crear Nueva Liga',
  'leagues.enter_club': 'Entrar al Club',
  'leagues.enter_club_placeholder': 'Introduce el nombre de tu club (ej. Burbia FC)',
  'leagues.enter_code': 'Introduce el código de invitación:',
  'leagues.enter_league': 'Entrar a la Liga',
  'leagues.error_title': 'Error al consultar competiciones',
  'leagues.global_competition': 'Competición Global',
  'leagues.global_tab': 'Ligas Globales',
  'leagues.invite_code_label': 'Código de Invitación (ej. PRIV-9872)',
  'leagues.join_action': 'Unirme',
  'leagues.join_closed': 'INSCRIPCIÓN CERRADA',
  'leagues.join_code_btn': 'Unirse con Código',
  'leagues.join_modal_title': 'Unirse a Liga Privada',
  'leagues.join_open': 'INSCRIPCIÓN ABIERTA',
  'leagues.join_with_code': 'Unirse con Código',
  'leagues.league_name': 'Nombre de la Liga',
  'leagues.league_name_label': 'Nombre de la Liga',
  'leagues.main_league': 'Liga Principal',
  'leagues.managing_club': 'Estás dirigiendo al',
  'leagues.members': 'mánagers',
  'leagues.my_competitions': 'Mis Competiciones y Ligas Activas',
  'leagues.no_private': 'No tienes ligas privadas activas actualmente. ¡Crea una o únete con un código!',
  'leagues.no_private_leagues': 'No perteneces a ninguna liga privada todavía',
  'leagues.no_private_leagues_desc': 'Crea tu propia liga de amigos para competir por jornada con normas y fichajes propios, o únete usando el código de invitación que te hayan facilitado.',
  'leagues.not_available': 'No disponible',
  'leagues.official_badge': 'OFICIAL',
  'leagues.official_competition': 'Competición Oficial',
  'leagues.official_desc': 'Inscríbete en la competición global creando tu club. Competirás en el sistema de divisiones oficial con ascensos, descensos y ciclos competitivos.',
  'leagues.participants_count': 'Número de Participantes',
  'leagues.play_league': 'Jugar esta liga',
  'leagues.primary_color': 'Color Principal',
  'leagues.private_disabled': 'Las ligas privadas están deshabilitadas actualmente en esta temporada.',
  'leagues.private_leagues': 'Ligas Privadas',
  'leagues.private_tab': 'Ligas Privadas',
  'leagues.registering_club': 'Registrando club...',
  'leagues.registrations_not_open': 'Las inscripciones para la competición global no están abiertas en este momento.',
  'leagues.resume_game': 'Continuar Partida (Dashboard)',
  'leagues.round_of': 'Jornada {current} de {total}',
  'leagues.selection_desc': 'Selecciona la liga en la que deseas competir. Cada competición gestiona de manera aislada tu club, plantilla, economía, finanzas del estadio y resultados de los partidos.',
  'leagues.subtitle': 'Elige tu competición oficial o accede a una liga privada con tus amigos.',
  'leagues.teams': 'Equipos',
  'leagues.title': 'Centro de Ligas y Competiciones',
  'leagues.validate_and_enter': 'Validar Código y Entrar',
  'leagues.your_club': 'Tu Club',
  'loans.active': 'activa(s)',
  'loans.amount_label': 'Importe del Préstamo (M€)',
  'loans.desc': 'Solicita financiación hasta un máximo de 25 M€ a un tipo de interés fijo del 6% anual.',
  'loans.instalment': 'Cuota por temporada',
  'loans.max_credit_capacity': 'Capacidad Máxima de Crédito',
  'loans.request_btn': 'Solicitar Concesión Inmediata',
  'loans.season_singular': 'Temporada',
  'loans.seasons_plural': 'Temporadas',
  'loans.term_label': 'Plazo de Amortización (Temporadas)',
  'loans.title': 'Línea de Crédito Bancario',
  'loans.total_repay': 'Total a devolver (con 6% int.)',
  'loans.year_suffix': 'año',
  'market.add_watchlist': 'Añadir a Cartera',
  'market.available_balance': 'Saldo Disponible Fichajes',
  'market.badge': 'Mercado, Ofertas & Cartera',
  'market.balance': 'Saldo Disponible Fichajes',
  'market.buyout': 'Clausulazo',
  'market.daily_bidding': 'Licitación Diaria',
  'market.closes_at': 'Cierre',
  'market.cancel': 'Cancelar',
  'market.cancel_offer': 'Cancelar Oferta',
  'market.club_balance': 'Saldo Club',
  'market.contract_years': 'Duración (Años)',
  'market.desc': 'Negociación objetiva de contratos, estado de ofertas activas y cartera de futbolistas en seguimiento.',
  'market.empty_market': 'No se encontraron futbolistas con los filtros seleccionados.',
  'market.error_funds_reservation_rejected': 'Reserva de fondos rechazada. Saldo insuficiente para presentar la oferta.',
  'market.error_funds_reservation_rejected_details': 'Saldo insuficiente para presentar la oferta. Necesitas {requestedAmount} y tienes {availableAmount} disponibles.',
  'market.error_insufficient_funds': 'Saldo insuficiente para presentar la oferta. Necesitas {requestedAmount} y tienes {availableAmount} disponibles.',
  'market.eval_accept': 'El futbolista aceptará esta propuesta',
  'market.eval_reject': 'Propuesta insuficiente para el jugador',
  'market.filter_all': 'Todos',
  'market.filter_att': 'DEL',
  'market.filter_def': 'DEF',
  'market.filter_gk': 'POR',
  'market.filter_mid': 'MED',
  'market.free_badge': 'Agente Libre',
  'market.loading_agents': 'cargando...',
  'market.modal_edit_title': 'Modificar Oferta Activa por {name}',
  'market.modal_title': 'Propuesta de Contrato a {name}',
  'market.negotiate': 'Negociar Contrato',
  'market.no_offers': 'No tienes ofertas activas de traspaso en este momento.',
  'market.no_watchlist': 'Tu cartera de seguimiento está vacía. Marca futbolistas con el icono de marcador para seguirlos.',
  'market.offered_clause': 'Nueva Cláusula de Rescisión (M€)',
  'market.offered_salary': 'Ficha Anual Propuesta (M€)',
  'market.offers_all': 'Todas',
  'market.offers_market_targets': 'Objetivos de Mercado',
  'market.offers_sent': 'Mis Ofertas Emitidas',
  'market.only_free': 'Solo Libres',
  'market.remove_sale': 'Retirar de Transferibles',
  'market.remove_watchlist': 'Quitar de Cartera',
  'market.required_funds': 'Coste Inicial Total',
  'market.search_placeholder': 'Buscar futbolista...',
  'market.signing_bonus': 'Prima de Fichaje (M€)',
  'market.submit_offer': 'Formalizar Oferta',
  'market.subtab_active_offers': 'Ofertas Activas',
  'market.subtab_history_offers': 'Historial de Ofertas',
  'market.history_title': 'Historial de Pujas por Jugadores Libres',
  'market.history_desc': 'Registro histórico de ofertas presentadas, resoluciones de licitaciones y pujas ganadas o perdidas.',
  'market.history_filter_all': 'Todas',
  'market.history_filter_won': 'Ganadas',
  'market.history_filter_lost': 'Perdidas',
  'market.history_filter_cancelled': 'Canceladas',
  'market.history_won_badge': 'Contratado',
  'market.history_lost_badge': 'Superada',
  'market.history_cancelled_badge': 'Oferta Cancelada',
  'market.rejection_reason_title': 'Motivo del rechazo',
  'market.rejection_reason_ACCEPTED_OTHER_CLUB': 'Aceptó la oferta de otro club',
  'market.rejection_reason_RELEASE_CLAUSE_TOO_HIGH': 'Cláusula de rescisión demasiado alta',
  'market.rejection_reason_ECONOMIC_OFFER_TOO_LOW': 'Oferta económica insuficiente',
  'market.history_empty': 'No se encontraron ofertas en el historial con los criterios seleccionados.',
  'market.history_total_won': 'Fichajes Ganados',
  'market.history_total_lost': 'Ofertas Perdidas',
  'market.history_total_cancelled': 'Canceladas',
  'market.history_total_invested': 'Inversión Ganada',
  'market.history_search_placeholder': 'Filtrar por nombre de futbolista...',
  'market.subtab_market': 'Mercado',
  'market.subtab_my_sales': 'Ventas',
  'market.subtitle': 'Negociación objetiva de contratos y cláusulas de rescisión con control de fondos.',
  'market.tab_market': 'Jugadores',
  'market.tab_offers': 'Ofertas',
  'market.tab_watchlist': 'Cartera',
  'market.title': 'Mercado de Fichajes y Contrataciones',
  'market.transfer_fee': 'Precio de Traspaso al Club (M€)',
  'market.transfer_offer': 'Oferta Formal',
  'market.update_offer': 'Guardar Cambios',
  'match.away': 'Visitante',
  'match.badge': 'Simulación de Partidos',
  'match.batch_notice': 'Gestión batch automatizada en backend',
  'match.col_goals': 'Goles',
  'match.col_player': 'Futbolista',
  'match.col_points': 'Puntos Fantasy',
  'match.col_pos': 'Pos',
  'match.col_reds': 'Rojas',
  'match.col_stars': 'Estrellas Prensa (1-5★)',
  'match.col_yellows': 'Amarillas',
  'match.cycle_title': 'Fases del Ciclo de Jornada',
  'match.editorial_desc': 'Puntuaciones oficiales (1-5 estrellas) y eventos para calcular los puntos fantasy.',
  'match.editorial_title': 'Panel Editorial de Prensa Deportiva',
  'match.home': 'Local',
  'match.match_attendance': 'Asistencia Registrada:',
  'match.match_goals': 'Goles del Partido:',
  'match.mod_attendance': 'Presión Ambiental / Aforo Local',
  'match.mod_attendance_desc': 'Bonus por porcentaje de ocupación del estadio',
  'match.mod_momentum': 'Inercia Positiva (Momentum)',
  'match.mod_momentum_desc': 'Racha de victorias en los últimos 5 partidos',
  'match.mod_staff': 'Preparación de Staff Técnico',
  'match.mod_staff_desc': 'Media de estrellas del cuerpo técnico',
  'match.next_btn': 'Avanzar a la Siguiente Jornada',
  'match.not_sent_off': 'No',
  'match.phase1_desc': 'Alineación Abierta',
  'match.phase2_desc': 'XI Congelado',
  'match.phase3_desc': 'Puntos Calculados',
  'match.phase4_desc': 'Jornada Cerrada',
  'match.publish_btn': 'Publicar Calificaciones Oficiales',
  'match.sent_off': 'Expulsado',
  'match.simulate_btn': 'Calcular y Simular Jornada {round}',
  'match.subtitle': 'Ciclo de jornada: PLANNED → OPEN → LOCKED → SCORED → CLOSED. Rendimiento deportivo.',
  'match.tab_editorial': 'Calificaciones de Prensa',
  'match.tab_engine': 'Modificadores de Rendimiento',
  'match.tactical_desc': 'Cálculo de factores multiplicadores aplicados por el motor de simulación.',
  'match.tactical_title': 'Modificadores Tácticos y de Rendimiento',
  'match.ticket_revenue': 'Recaudación de Taquilla:',
  'match.title': 'Centro de Jornada & Match Engine',
  'match.user_fixture_title': 'Encuentro de Tu Club en Jornada {round}',
  'matches.away_label': 'Visitante',
  'matches.batch_info': 'Gestión batch automatizada en backend',
  'matches.col_fantasy_pts': 'Puntos Fantasy',
  'matches.col_goals': 'Goles',
  'matches.col_player': 'Futbolista',
  'matches.col_pos': 'Pos',
  'matches.col_press_stars': 'Estrellas Prensa (1-5★)',
  'matches.col_reds': 'Rojas',
  'matches.col_yellows': 'Amarillas',
  'matches.desc': 'Ciclo de jornada: PLANNED → OPEN → LOCKED → SCORED → CLOSED. Backoffice de rendimiento deportivo y puntuaciones.',
  'matches.editorial_desc': 'Puntuaciones oficiales (1-5 estrellas) y eventos para calcular los puntos fantasy de la jornada.',
  'matches.editorial_title': 'Panel Editorial de Prensa Deportiva',
  'matches.home_label': 'Local',
  'matches.lineup_frozen': 'XI Congelado',
  'matches.lineup_open': 'Alineación Abierta',
  'matches.match_goals': 'Goles del Partido',
  'matches.mod_attendance': 'Presión Ambiental / Aforo Local',
  'matches.mod_attendance_desc': 'Bonus por porcentaje de ocupación del estadio',
  'matches.mod_momentum': 'Inercia Positiva (Momentum)',
  'matches.mod_momentum_desc': 'Racha de victorias en los últimos 5 partidos',
  'matches.mod_staff': 'Preparación de Staff Técnico',
  'matches.mod_staff_desc': 'Media de estrellas del cuerpo técnico',
  'matches.not_sent_off': 'No',
  'matches.performance_mods': 'Modificadores de Rendimiento',
  'matches.phase': 'Fase',
  'matches.phases_title': 'Fases del Ciclo de Jornada',
  'matches.points_calculated': 'Puntos Calculados',
  'matches.press_ratings': 'Calificaciones de Prensa',
  'matches.publish_ratings': 'Publicar Calificaciones Oficiales',
  'matches.recorded_attendance': 'Asistencia Registrada',
  'matches.round_closed': 'Jornada Cerrada',
  'matches.sent_off': 'Expulsado',
  'matches.simulation_badge': 'Simulación de Partidos',
  'matches.spectators_suffix': 'espectadores',
  'matches.tactical_mods_desc': 'Cálculo de factores multiplicadores aplicados por el motor de simulación para el próximo encuentro.',
  'matches.tactical_mods_title': 'Modificadores Tácticos y de Rendimiento',
  'matches.ticket_collection': 'Recaudación de Taquilla',
  'matches.title': 'Centro de Jornada & Match Engine',
  'matches.user_fixture_title': 'Encuentro de Tu Club en Jornada',
  'nav.all_leagues': 'Ver todas / Unirse a otra liga...',
  'nav.api': 'API',
  'nav.budget': 'Presupuesto',
  'nav.club': 'Club',
  'nav.news': 'Noticias',
  'nav.competition': 'Competición',
  'nav.competition_context': 'Contexto de Competición',
  'nav.credits': 'Créditos (CR)',
  'nav.dark_mode_enabled': 'Modo Oscuro activado',
  'nav.dark_mode_title': 'Modo Oscuro / Claro',
  'nav.dashboard': 'Dashboard',
  'nav.language': 'Idioma',
  'nav.light_mode_enabled': 'Modo Claro activado',
  'nav.logout': 'Cerrar Sesión',
  'nav.market': 'Mercado',
  'nav.matchengine': 'Jornada',
  'nav.next_matchday': 'Avanzar a J{round}',
  'nav.settings': 'Ajustes',
  'nav.simulate': 'Simular J{round}',
  'nav.squad': 'Plantilla',
  'nav.stadium': 'Club',
  'nav.switch_league': 'Cambiar de liga',
  'nav.toggle_theme_dark': 'Modo Oscuro',
  'nav.toggle_theme_light': 'Modo Claro',
  'settings.lang_desc': 'Disponible en los 4 idiomas oficiales (Español, Català, Galego y Euskara).',
  'settings.lang_title': 'Seleccionar Idioma de la Plataforma',
  'settings.notifications_desc': 'Visualizar avisos informativos y de éxito (si se desactiva, solo se mostrarán errores).',
  'settings.notifications_disabled': 'Solo Errores',
  'settings.notifications_enabled': 'Activadas',
  'settings.notifications_title': 'Notificaciones del Sistema',
  'settings.profile_club': 'Club Actual Asignado',
  'settings.profile_desc': 'Datos de la cuenta de usuario y credenciales de acceso.',
  'settings.profile_email': 'Correo de Contacto',
  'settings.profile_info': 'Información del Mánager',
  'settings.profile_logout': 'Cerrar Sesión Oficial',
  'settings.profile_name': 'Nombre Oficial',
  'settings.profile_role': 'Rol en el Sistema',
  'settings.profile_version': 'Versión de la Plataforma',
  'settings.separation_desc': 'La tesorería del club está completamente desvinculada de los créditos de usuario. Tu Wallet personal de créditos (CR) se administra de forma independiente en Ajustes.',
  'settings.separation_title': 'Separación de Fondos',
  'settings.subtitle': 'Configuración, preferencias y Wallet de créditos personales',
  'settings.tab_preferences': 'Preferencias',
  'settings.tab_profile': 'Perfil',
  'settings.tab_wallet': 'Wallet (CR)',
  'settings.theme_dark': 'Modo Oscuro (Noche)',
  'settings.theme_desc': 'Alterna entre el modo claro y el modo oscuro optimizado para baja luminosidad.',
  'settings.theme_light': 'Modo Claro (Día)',
  'settings.theme_title': 'Tema Visual de la Aplicación',
  'settings.title': 'Ajustes del Mánager',
  'shield.customize': 'Personalizar escudo',
  'shield.title': 'Personalización del escudo',
  'shield.subtitle': 'Diseño vectorial, colores e iniciales del club',
  'settings.wallet_balance': 'Saldo en Wallet',
  'settings.wallet_benefit_analytics': 'Módulos analíticos avanzados',
  'settings.wallet_benefit_fee': 'Licencia federativa mensual',
  'settings.wallet_benefit_leagues': 'Ligas VIP entre mánagers',
  'settings.wallet_best_value': 'Mejor Valor',
  'settings.wallet_desc': 'Créditos personales de mánager independientes de la tesorería del club.',
  'settings.wallet_explanation': 'Los créditos (CR) pertenecen a tu cuenta personal y no se mezclan con los fondos ni el presupuesto del club.',
  'settings.wallet_monthly_fee': 'Cuota mensual de licencia',
  'settings.wallet_open': 'Gestionar Wallet',
  'settings.wallet_pay_fee': 'Abonar Cuota Mensual (-100 CR)',
  'settings.wallet_personal_funds': 'Fondos Personales',
  'settings.wallet_popular': 'Popular',
  'settings.wallet_recharge': 'Recargar Créditos',
  'settings.wallet_recharge_btn': 'Recargar {cr} CR',
  'settings.wallet_recharge_instant': 'Recarga inmediata al monedero',
  'settings.wallet_title': 'Wallet del Mánager (CR)',
  'squad.age': 'años',
  'squad.auto_pick': 'Auto',
  'squad.badge_management': 'Gestión de Once',
  'squad.cancel': 'Cancelar',
  'squad.clause': 'Cláusula',
  'squad.col_actions': 'Acciones',
  'squad.col_age': 'Edad',
  'squad.col_clause': 'Cláusula',
  'squad.col_number': '#',
  'squad.col_ovr': 'OVR',
  'squad.col_player': 'Futbolista',
  'squad.col_pos': 'Pos',
  'squad.col_salary': 'Ficha',
  'squad.col_status': 'Estado',
  'squad.confirm_renew': 'Confirmar Renovación',
  'squad.desc': 'Exactamente 11 titulares para la Jornada. Sin sustituciones en directo.',
  'squad.formation': 'Formación',
  'squad.lock_xi': 'Bloquear XI',
  'squad.locked_xi': 'XI Bloqueado',
  'squad.new_clause': 'Nueva Cláusula (M€)',
  'squad.new_salary': 'Nueva Ficha Anual (M€)',
  'squad.new_years': 'Años de Contrato',
  'squad.ovr': 'Media OVR',
  'squad.pos_def': 'Defensa',
  'squad.pos_del': 'Delantero',
  'squad.pos_df': 'DEF',
  'squad.pos_fw': 'DEL',
  'squad.pos_gk': 'POR',
  'squad.pos_med': 'Centrocampista',
  'squad.pos_mf': 'MED',
  'squad.pos_por': 'Portero',
  'squad.put_transferable': 'Poner en venta',
  'squad.remove_transferable': 'Retirar de venta',
  'squad.renew_contract': 'Renovar Contrato',
  'squad.renew_modal_title': 'Renovación de Contrato',
  'squad.salary': 'Ficha Anual',
  'squad.save_lineup': 'Guardar',
  'squad.saved': 'Guardado',
  'squad.saving': 'Guardando...',
  'squad.starters_count': 'Titulares',
  'squad.starting_xi': 'Once Titular ({count}/11)',
  'squad.substitutes': 'Banquillo y Reservas ({count})',
  'squad.subtitle': 'Configura tu táctica, formación y alineación para la próxima jornada.',
  'squad.tactical_board': 'Formación',
  'squad.title': 'Plantilla y Táctica',
  'squad.transfer_status': 'Estado',
  'squad.transferable': 'Transferible',
  'squad.years': 'años',
  'stadium.attendance_sim_note': 'Estimación según precio e instalaciones actuales, con clasificación neutral y sin bonus de racha en casa. Los ingresos comerciales usan tarifas orientativas; el resultado real puede variar.',
  'stadium.attendance_sim_title': 'Simulación de Aforo Previsto',
  'stadium.badge': 'Infraestructura & Finanzas',
  'stadium.cafeteria_desc': 'Aumenta las ventas de comida y bebida durante los descansos.',
  'stadium.cafeteria_title': 'Cafeterías & Hostelería',
  'stadium.capacity_desc': 'Aumenta la capacidad del estadio para generar mayores ingresos en taquilla.',
  'stadium.capacity_label': 'Aforo',
  'stadium.capacity_title': 'Ampliación de Gradas y Aforo',
  'stadium.capacity_upgrade_title': 'Ampliación de Gradas y Aforo',
  'stadium.commercial_modules_title': 'Módulos Comerciales y Explotación',
  'stadium.confirm_pricing': 'Confirmar Precios para Próximo Partido',
  'stadium.confirm_tickets': 'Confirmar Precios para Próximo Partido',
  'stadium.current': 'Actual',
  'stadium.current_tier': 'Aforo Vigente',
  'stadium.desc': 'Precios, aforo, módulos comerciales, cuerpo técnico, créditos bancarios y contabilidad.',
  'stadium.economy_tier': 'Económico',
  'stadium.est_attendance': 'Ocupación Estimada:',
  'stadium.expense': 'GASTO',
  'stadium.general_ticket': 'Precio Entrada General',
  'stadium.general_ticket_price': 'Precio Entrada General',
  'stadium.income': 'INGRESO',
  'stadium.ledger_amount': 'Importe',
  'stadium.ledger_balance': 'Saldo Resultante',
  'stadium.ledger_concept': 'Concepto',
  'stadium.ledger_date': 'Fecha',
  'stadium.ledger_desc': 'Registro contable',
  'stadium.ledger_entries': '{count} apuntes registrados',
  'stadium.ledger_title': 'Transacciones',
  'stadium.ledger_type': 'Tipo',
  'stadium.level': 'Nivel',
  'stadium.loan_amount': 'Importe del Préstamo (M€)',
  'stadium.loan_apply': 'Solicitar Concesión Inmediata',
  'stadium.loan_desc': 'Solicita financiación hasta un máximo de 25 M€ a un tipo de interés fijo del 6% anual.',
  'stadium.loan_installment': 'Cuota por temporada:',
  'stadium.loan_title': 'Línea de Crédito Bancario',
  'stadium.loan_total': 'Total a devolver (con 6% int.):',
  'stadium.loan_years': 'Plazo de Amortización (Temporadas)',
  'stadium.max_level': 'Nivel Máximo',
  'stadium.merchandising_desc': 'Venta de camisetas y bufandas oficiales en días de partido.',
  'stadium.merchandising_title': 'Tiendas Oficiales',
  'stadium.mod_cafeteria': 'Cafeterías & Hostelería',
  'stadium.mod_level': 'Nivel {level}/5',
  'stadium.mod_max': 'Nivel Máximo',
  'stadium.mod_merch': 'Tiendas Oficiales',
  'stadium.mod_parking': 'Parking Estadio',
  'stadium.modules_desc': 'Mejora las instalaciones comerciales para incrementar los ingresos por aficionado en cada partido.',
  'stadium.modules_title': 'Módulos Comerciales y Explotación',
  'stadium.parking_desc': 'Mejora el ingreso por butaca y la comodidad de los aficionados.',
  'stadium.parking_title': 'Parking Estadio',
  'stadium.passed_tier': 'Superado',
  'stadium.premium_tier': 'Premium',
  'stadium.pricing_desc': 'Ajusta el precio medio de las entradas generales para optimizar la taquilla según la demanda y la forma del equipo.',
  'stadium.pricing_title': 'Fijación de Precios de Entradas',
  'stadium.proj_commercial': 'Ingresos Comerciales (Parking/Bar):',
  'stadium.proj_tickets': 'Ingresos Taquilla Proyectados:',
  'stadium.projected_commercial': 'Ingresos Comerciales (Parking/Bar)',
  'stadium.projected_tickets': 'Ingresos Taquilla Proyectados',
  'stadium.reserved_funds': 'Fondo Reservado',
  'stadium.seats': 'Asientos',
  'stadium.sim_title': 'Simulación de Aforo Previsto',
  'stadium.staff_desc': 'Cada área de preparación incrementa el rendimiento del equipo en el motor de partido.',
  'stadium.staff_fitness': 'Entrenador de Defensas',
  'stadium.staff_gk': 'Entrenador de Porteros',
  'stadium.staff_shooting': 'Entrenador de Delanteros',
  'stadium.staff_tech': 'Entrenador de Centrocampistas',
  'stadium.staff_title': 'Cuerpo Técnico y Preparadores',
  'stadium.staff_upgrade': '+0.5★ (0.5 M€)',
  'stadium.standard_tier': 'Estándar',
  'stadium.stands_level': 'Gradas Nivel',
  'stadium.sub_balance': 'Saldo Actual de Créditos:',
  'stadium.sub_cost': 'Coste Cuota Mensual:',
  'stadium.sub_desc': 'Gestión de cuota mensual y créditos para partidas y simulaciones avanzadas.',
  'stadium.sub_pay': 'Abonar Cuota Mensual (-100 CR)',
  'stadium.sub_title': 'Suscripción y Créditos (CR)',
  'stadium.subtitle': 'Precios, aforo, módulos comerciales, cuerpo técnico, créditos bancarios y contabilidad.',
  'stadium.surpassed_tier': 'Superado',
  'stadium.sync_server': 'Sincronizar datos con el servidor',
  'stadium.tab_economy': 'Economía',
  'stadium.tab_stadium': 'Estadio',
  'stadium.tab_staff': 'Staff',
  'stadium.ticket_desc': 'Ajusta el precio medio de las entradas generales para optimizar la taquilla según la demanda y la forma del equipo.',
  'stadium.ticket_title': 'Fijación de Precios de Entradas',
  'stadium.title': 'Finanzas',
  'stadium.total_capacity': 'Aforo Total del Estadio:',
  'stadium.treasury': 'Tesorería',
  'stadium.upgrade_btn': 'Ampliar',
  'stadium.upgrade_level_btn': 'Mejorar Nivel',
  'stadium.upgrade_module': 'Mejorar Nivel ({cost} M€)',
  'stadium.bathrooms_title': 'Aseos y Sanitarios',
  'stadium.bathrooms_desc': 'Moderniza la higiene y confort de los aficionados en las gradas.',
  'stadium.status.requested': 'Solicitud pendiente de financiación',
  'stadium.status.funds_confirmed': 'Obra en curso',
  'stadium.status.funds_captured': 'Obra en curso',
  'stadium.status.capture_pending': 'Finalizando la mejora',
  'stadium.status.cancel_requested': 'Cancelación en curso',
  'stadium.status.reversal_pending': 'Reversión económica en curso',
  'stadium.status.applied': 'Mejora aplicada',
  'stadium.status.failed': 'Solicitud fallida',
  'stadium.status.cancelled': 'Solicitud cancelada',
  'stadium.construction_active_title': 'Obra Activa de Remodelación',
  'stadium.construction_none': 'No hay ninguna obra activa en este momento',
  'stadium.construction_none_desc': 'El estadio está a pleno rendimiento. Puedes solicitar un presupuesto de gradas o instalaciones.',
  'stadium.cancel_btn': 'Cancelar Obra',
  'stadium.cancel_confirm_msg': '¿Seguro que deseas cancelar esta obra? La solicitud se anulará de forma asíncrona.',
  'stadium.retry_btn': 'Reintentar Solicitud',
  'stadium.quote_modal_title': 'Presupuesto de Remodelación',
  'stadium.quote_confirm_btn': 'Confirmar y Contratar Obra',
  'stadium.quote_requesting': 'Calculando presupuesto oficial...',
  'stadium.quote_accepting': 'Contratando remodelación...',
  'stadium.quote_warning': 'El presupuesto no reserva dinero ni devuelve una fecha de finalización garantizada. La solicitud se procesa de forma asíncrona tras la confirmación.',
  'staff.annual_cost': 'Coste Anual',
  'staff.desc': 'Staff técnico oficial y preparadores especializados que potencian el rendimiento competitivo del club.',
  'staff.fitness_coach': 'Entrenador de Defensas',
  'staff.goalkeeping_coach': 'Entrenador de Porteros',
  'staff.modifier': 'Modificador',
  'staff.on_payroll': 'preparadores en nómina',
  'staff.quality_level': 'Nivel / Calidad',
  'staff.shooting_coach': 'Entrenador de Delanteros',
  'staff.tactical_coach': 'Entrenador de Centrocampistas',
  'staff.title': 'Cuerpo Técnico y Preparadores',
  'stadium.tab_sponsors': 'Sponsors',
  'sponsors.title': 'Patrocinios Comerciales',
  'sponsors.desc': 'Gestiona los patrocinios del club para la jornada en curso e impulsa los ingresos de tu tesorería.',
  'sponsors.my_sponsors_title': 'Mis Sponsors Contratados',
  'sponsors.my_sponsors_desc': 'Contratos activos y pendientes de activación.',
  'sponsors.market_title': 'Ofertas de la Jornada',
  'sponsors.market_desc': 'Ofertas vigentes agrupadas por tipo: vallas publicitarias, camiseta y estadio.',
  'sponsors.type_billboard': 'Vallas Publicitarias (BILLBOARD)',
  'sponsors.type_shirt': 'Camiseta Oficial (SHIRT)',
  'sponsors.type_stadium': 'Naming del Estadio (STADIUM)',
  'sponsors.fixed_initial': 'Ingreso Inicial del Contrato',
  'sponsors.win_bonus': 'Bonus por Victoria',
  'sponsors.duration': 'Duración Efectiva',
  'sponsors.remaining': 'Jornadas restantes',
  'sponsors.accumulated': 'Ingresos Acumulados',
  'sponsors.status_active': 'Activo',
  'sponsors.status_pending': 'Pendiente de activación',
  'sponsors.status_expired': 'Caducado',
  'sponsors.btn_contract': 'Contratar',
  'sponsors.type_occupied': 'Tipo de patrocinio ya ocupado',
  'sponsors.modal_title': 'Confirmar Contratación de Patrocinio',
  'sponsors.modal_confirm': 'Confirmar y Firmar Contrato',
  'sponsors.modal_desc': 'Revisa las condiciones económicas del patrocinador antes de formalizar la contratación.',
  'sponsors.empty_contracts': 'No hay contratos de patrocinio vigentes en este momento.',
  'sponsors.empty_contracts_sub': 'Consulta las ofertas de la jornada para firmar patrocinios en vallas, camiseta o estadio.',
  'sponsors.empty_market': 'No hay ofertas de patrocinio disponibles para la jornada actual.',
  'sponsors.market_503': 'El mercado de patrocinios no está disponible temporalmente.',
  'sponsors.retry_market': 'Reintentar Consulta',
  'sponsors.disabled_reasons.CATEGORY_OCCUPIED': 'Contrato en vigor',

  // Coaches (Entrenadores)
  'coaches.title': 'Entrenadores',
  'coaches.tab_market': 'Mercado',
  'coaches.tab_my_coach': 'Mi Entrenador',
  'coaches.tab_offers': 'Ofertas Presentadas',
  'coaches.daily_market': 'Mercado Diario de Entrenadores',
  'coaches.daily_market_desc': 'Técnicos libres disponibles hoy para pujar por sus servicios e incorporar sus bonificaciones a las líneas del equipo.',
  'coaches.closes_at': 'Cierre',
  'coaches.time_left': 'Tiempo restante',
  'coaches.closed': 'Mercado Cerrado (procesando adjudicación)',
  'coaches.empty_market': 'No hay entrenadores disponibles en el mercado hoy',
  'coaches.empty_market_desc': 'El mercado no dispone de más técnicos libres para esta jornada. La selección de hasta tres entrenadores se renovará en la próxima fecha.',
  'coaches.attack': 'Ataque',
  'coaches.midfield': 'Control',
  'coaches.defense': 'Defensa',
  'coaches.bonus_sum_info': 'Las mejoras tácticas suman exactamente un 15% entre las tres líneas del equipo.',
  'coaches.submit_offer': 'Presentar Oferta',
  'coaches.modify_offer': 'Modificar Oferta',
  'coaches.cancel_offer': 'Cancelar Oferta',
  'coaches.has_pending_offer': 'Tienes una oferta activa por este técnico',
  'coaches.offer_modal_title': 'Ofertar por Entrenador',
  'coaches.signing_bonus': 'Prima de Fichaje (€)',
  'coaches.annual_salary': 'Salario de Temporada (€)',
  'coaches.release_clause': 'Cláusula de Rescisión (€)',
  'coaches.score': 'Puntuación de Puja',
  'coaches.score_formula': 'Puntuación = Prima × 60% + Salario × 40%',
  'coaches.score_explanation': 'Gana la mayor puntuación entre los clubes licitadores. En caso de empate exacto, prevalece la primera recibida. La cláusula no interviene en la puntuación.',
  'coaches.disclaimer_bonus': 'La prima se cobrará al adjudicar el fichaje; enviar la oferta no reserva saldo ni garantiza la contratación.',
  'coaches.disclaimer_salary': 'El salario se cobrará prorrateado entre las jornadas restantes de la temporada al cierre de cada una.',
  'coaches.disclaimer_replacement': 'Aviso de sustitución: si ganas la puja y ya tienes entrenador contratado, su contrato quedará rescindido e indemnizarás sus jornadas pendientes.',
  'coaches.disclaimer_multiple': 'Solo puedes tener una oferta de entrenador activa por club y liga. Para cambiarla, cancélala antes del cierre y presenta otra; perderás la prioridad de llegada original.',
  'coaches.offers_unverified': 'No puedes pujar hasta verificar tus ofertas.',
  'coaches.retry': 'Reintentar',
  'coaches.checking_offers': 'Comprobando ofertas activas…',
  'coaches.uncertain_offer': 'No se pudo confirmar el envío. Reintenta la misma oferta con los mismos importes antes de presentar otra.',
  'coaches.active_offer': 'Ya tienes una oferta activa',
  'coaches.awaiting_resolution': 'Pendiente de resolución: no puedes cancelar ni presentar otra oferta hasta que se resuelva.',
  'coaches.cancel_before_new': 'Para cambiar de entrenador o modificar los importes, cancela primero esta oferta antes del cierre.',
  'coaches.view_offer': 'Ver oferta activa',
  'coaches.status_pending': 'Pendiente',
  'coaches.status_won': 'Adjudicada',
  'coaches.status_lost': 'No adjudicada',
  'coaches.status_insufficient_funds': 'Saldo insuficiente',
  'coaches.status_cancelled': 'Cancelada',
  'coaches.active_coach': 'Entrenador del Club',
  'coaches.active_coach_desc': 'Condiciones contractuales y bonificaciones tácticas aplicadas a tu equipo.',
  'coaches.no_active_coach': 'Sin entrenador contratado',
  'coaches.no_active_coach_desc': 'Tu club no cuenta con un entrenador en activo. Las líneas de tu equipo rinden actualmente con una bonificación neutral (+0%).',
  'coaches.contract_history': 'Historial de Contratos',
  'coaches.contract_active': 'Vigente',
  'coaches.contract_terminated': 'Rescindido',
  'coaches.contract_expired': 'Vencido',
  'coaches.go_to_market': 'Fichar en el Mercado de Entrenadores',
  'coaches.ledger_signing_bonus': 'Prima de fichaje de entrenador',
  'coaches.ledger_termination': 'Indemnización por despido de entrenador',
  'coaches.ledger_salary': 'Salario de entrenador',
  'coaches.match_frozen_notice': 'El entrenador queda congelado al inicio de la jornada. Una contratación posterior no altera el partido en curso.',
  'coaches.match_included_notice': 'Las potencias calculadas por el motor ya incorporan la mejora de este entrenador.',
};
